import { render, staticRenderFns } from "./PostosSelect.vue?vue&type=template&id=32bf20de&"
import script from "./PostosSelect.vue?vue&type=script&lang=js&"
export * from "./PostosSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports